import Head from "next/head";

import BecomeAPartnerMain from "@/components/become-a-partner/become-a-partner-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function BecomeAPartner() {
  return (
    <>
      <Head>
        <title>{seoData.BECOME_A_PARTNER.title}</title>
        <SeoMetaData data={seoData.BECOME_A_PARTNER} />
      </Head>

      <BecomeAPartnerMain />
    </>
  );
}
